'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoArrowLeftC = function IoArrowLeftC(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm14.5 10c1-0.9 2.5-0.9 3.5 0s0.9 2.7 0 3.6l-3.9 3.9h17c1.3 0 2.4 1.1 2.4 2.5s-1.1 2.5-2.4 2.5h-17l3.8 3.9c0.9 0.9 0.9 2.7 0 3.6s-2.4 0.9-3.4 0l-7.8-8.3c-0.5-0.4-0.7-1-0.7-1.7s0.2-1.3 0.7-1.8z' })
        )
    );
};

exports.default = IoArrowLeftC;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/arrow-left-c.js
// module id = 1970
// module chunks = 0